(() => {
  const script = document.currentScript;
  const favicon = document.querySelector('link[rel~="icon"]');

  if (!script || !favicon || window.matchMedia('(prefers-reduced-motion: reduce)').matches) return;

  const original = favicon.href;
  const frames = [script.dataset.open, script.dataset.half, script.dataset.open];
  let delayId;
  let frameId;
  let played = false;

  function stop() {
    clearTimeout(delayId);
    clearInterval(frameId);
    delayId = undefined;
    frameId = undefined;
    favicon.href = original;
  }

  function play() {
    played = true;
    delayId = undefined;
    let frame = 0;

    favicon.href = frames[frame++];
    frameId = setInterval(() => {
      if (!document.hidden || frame === frames.length) {
        stop();
        return;
      }

      favicon.href = frames[frame++];
    }, 1000);
  }

  function schedule() {
    if (!played && !delayId && document.hidden) delayId = setTimeout(play, 90000);
  }

  document.addEventListener('visibilitychange', () => {
    if (document.hidden) schedule();
    else stop();
  });

  schedule();
})();
